import { render, staticRenderFns } from "./IndemnityPriceTemplateDeleteModal.vue?vue&type=template&id=81fd296c&scoped=true"
import script from "./IndemnityPriceTemplateDeleteModal.vue?vue&type=script&lang=js"
export * from "./IndemnityPriceTemplateDeleteModal.vue?vue&type=script&lang=js"
import style0 from "./IndemnityPriceTemplateDeleteModal.vue?vue&type=style&index=0&id=81fd296c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81fd296c",
  null
  
)

export default component.exports